import { Server, Monitor, MonitorSmartphone, Network, Wrench, Layers, Cpu, Zap } from 'lucide-react';
import { tx } from '../../i18n/LanguageContext';

export const LEVEL_OPTS = [
  { key: 'beginner', dot: 'bg-emerald-500', ar: 'مبتدئ', en: 'Beginner' },
  { key: 'intermediate', dot: 'bg-amber-500', ar: 'متوسط', en: 'Intermediate' },
  { key: 'advanced', dot: 'bg-rose-500', ar: 'متقدم', en: 'Advanced' },
];

export const levelKey = (text = '') => {
  const t = String(text).toLowerCase();
  if (t.includes('مبتد') || t.includes('beginner') || t.includes('basic')) return 'beginner';
  if (t.includes('متقدم') || t.includes('advanced') || t.includes('expert')) return 'advanced';
  return 'intermediate';
};

export const LEVEL_BADGE = {
  beginner: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  intermediate: 'bg-amber-50 text-amber-700 border-amber-200',
  advanced: 'bg-rose-50 text-rose-700 border-rose-200',
};

export const levelLabel = (k, lang) => { const o = LEVEL_OPTS.find(x => x.key === k); return o ? tx(lang, o.ar, o.en) : ''; };

export const catsOf = (c) => (Array.isArray(c.categories) && c.categories.length ? c.categories : ['general']);

export const catIcon = (value = '') => {
  const v = value.toLowerCase();
  if (v.includes('plc')) return Server;
  if (v.includes('scada')) return Monitor;
  if (v.includes('hmi')) return MonitorSmartphone;
  if (v.includes('net') || v.includes('شبك')) return Network;
  if (v.includes('tool') || v.includes('soft')) return Wrench;
  if (v.includes('robot') || v.includes('cpu')) return Cpu;
  if (v.includes('elec') || v.includes('drive')) return Zap;
  return Layers;
};

export const fmtNum = (n) => Number(n || 0).toLocaleString('en-US');
